import { Components, Theme } from '@mui/material';
import { iconButtonClasses } from '@mui/material/IconButton';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';

import { getOutlinedInputClasses } from './helpers';

type MuiOutlinedInputTheme = Components<Theme>['MuiOutlinedInput'];

export const outlinedInputTheme: MuiOutlinedInputTheme = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      let height = 'var(--field-height)';
      if (ownerState.multiline) {
        height = `calc(${((ownerState.rows ?? 3) as number) * 20}px + ${theme.spacing(2.5)})`;
      } else if (ownerState.size === 'small') {
        height = '32px';
      }

      return {
        backgroundColor: theme.palette.common.white,
        minHeight: height,
        padding: 0,
        height,
        borderRadius: 'var(--field-border-radius)',
        color: 'var(--field-foreground-color)',
        ...(ownerState.color === 'primary' &&
          getOutlinedInputClasses(theme.palette.primary, outlinedInputClasses, 'default')),
        [`&.${outlinedInputClasses.focused}`]: {
          color: 'var(--field-focus-foreground-color)',
        },
        [`&.${outlinedInputClasses.disabled}`]: {
          backgroundColor: 'var(--field-disabled-background)',
          color: 'var(--field-disabled-foreground-color)',
        },
        ...((ownerState.color === 'error' || ownerState.error) &&
          getOutlinedInputClasses(theme.palette.error, outlinedInputClasses, 'attention')),
        ...(ownerState.color === 'warning' &&
          getOutlinedInputClasses(theme.palette.warning, outlinedInputClasses, 'attention')),
        [`& .${iconButtonClasses.root}`]: {
          color: 'var(--icon-secondary-color)',
        },
        [`&.${outlinedInputClasses.disabled} .${iconButtonClasses.root}`]: {
          color: 'var(--field-disabled-placeholder-color)',
        },
      };
    },
    input: ({ theme, ownerState }) => ({
      height: '100%',
      padding: ownerState.multiline ? theme.spacing(1.25, 1.5) : theme.spacing(0, 1.5),
      fontSize: ownerState.size === 'small' ? 'var(--font-size-paragraph-small)' : 'var(--field-font-size)',
      fontWeight: 'var(--field-font-weight)',
      lineHeight: 'var(--field-line-height)',
      ['&::placeholder']: {
        color: 'var(--field-placeholder-color)',
      },
      [`&.${outlinedInputClasses.disabled}::placeholder`]: {
        color: 'var(--field-disabled-placeholder-color)',
        opacity: 1,
      },
      [`&.${outlinedInputClasses.disabled}`]: {
        color: 'var(--field-disabled-foreground-color)',
        '-webkit-text-fill-color': 'var(--field-disabled-foreground-color)',
        background: 'var(--field-disabled-background)',
        borderColor: 'var(--field-disabled-border-color)',
        pointerEvents: 'none',
      },
    }),
    notchedOutline: ({ theme }) => ({
      borderWidth: 1,
      borderColor: theme.palette.grey[200],
      top: -10,
    }),
  },
};
